export default {"src":"/_next/static/media/logo-ausl.1a071317.svg","height":84,"width":193,"blurWidth":0,"blurHeight":0};